import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AdminUsersList from "./AdminUsersList";

const AdminPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Admin Users Management" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <AdminUsersList />
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default AdminPage;
